import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'

// Remove a locale prefix like `/en/` or `/fr/` from a pathname, returning the
// remainder without leading slashes.
export const removeLocalePrefixFromPath = (pathname: string): string => {
  const trimmed = pathname.replace(/^\/+/, '')
  const parts = trimmed.split('/')
  if (parts.length === 0) {
    return ''
  }

  const firstSegment = parts[0]
  const isLocalePrefix =
    firstSegment !== undefined &&
    (Object.values(PageLocaleEnum) as string[]).includes(firstSegment)

  if (!isLocalePrefix) {
    return trimmed
  }

  return parts.slice(1).join('/')
}
